import type {SearchResult} from '@miro-site/templates-design/src/components/search/Search'
import type {TemplateSearchData} from '../../utils/searchTemplates'

const toSearchResult = (data: TemplateSearchData): SearchResult => {
  const {title: fallbackTitle, description: fallbackDescription, slug} = data

  const {
    seoTitle = fallbackTitle,
    seoDescription = fallbackDescription,
    imageThumbnail: {
      file: {url: preview},
    },
  } = data.siteConfiguration || {}

  return {
    slug,
    href: slug,
    preview: preview,
    title: seoTitle,
    description: seoDescription,
  }
}

export default toSearchResult
